import React, { Fragment } from 'react'
import { HiOutlineBell, HiOutlineChatAlt, HiOutlineSearch } from 'react-icons/hi'
import { Popover, Transition, Menu } from '@headlessui/react'
import classNames from 'classnames'
import { useNavigate } from 'react-router-dom'
import { logoutUser } from '../../services/authService'
import { logout } from '../../reduxSlices/auth/authSlice'
import { useDispatch, useSelector } from 'react-redux'


function Header() {
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const user = useSelector((store) => store.auth.user);

    const handleNavigation = (pathOrFn) => {
        if (typeof window.guardedNavigate === 'function') {
            window.guardedNavigate(pathOrFn);
        } else {
            if (typeof pathOrFn === 'function') {
                pathOrFn();
            } else {
                navigate(pathOrFn);
            }
        }
    }


    return (
        <div className=' h-20 px-4 flex justify-between items-center bg-neutral-900'>
            <span className='text-gray-300 text-3xl font-thin'>Dashboard</span>
            {/* <div className='relative'>
            <HiOutlineSearch fontSize={24} className='text-gray-400 absolute top-1/2 -translate-y-1/2 left-3' />
            <input type='text' placeholder='Search' className='text-sm focus:outline-none active:outline-none h-10 w-[24rem] border border-gray-300 rounded-lg px-4 pl-11 bg-gray-200' />
        </div> */}
            <div className='flex item-center gap-2 mr-2'>

                <Popover className="relative">
                    {({ open }) => (
                        <>
                            <Popover.Button className={classNames(open && '', 'p-1.5 rounded-lg inline-flex items-center text-gray-700 hover:text-opacity-100 focus:outline-none')}>
                                <HiOutlineChatAlt color={open ? '#F48735' : 'gray'} fontSize={26} />

                            </Popover.Button>
                            <Transition
                                as={Fragment}
                                enter="transition ease-out duration-200"
                                enterFrom="opacity-0 translate-y-1"
                                enterTo="opacity-100 translate-y-0"
                                leave="transition ease-in duration-150"
                                leaveFrom="opacity-100 translate-y-0"
                                leaveTo="opacity-0 translate-y-1"
                            >
                                <Popover.Panel className='absolute right-0 z-10 mt-2.5 w-80'>
                                    <div className='bg-white rounded-sm shadow-md ring-1 ring-black ring-opacity-5 px-2 py-2.5'>
                                        <strong className='text-gray-700 font-medium'>Messages</strong>
                                        <div className='mt-2 py-1 text-sm'>
                                            This is the messages panel
                                        </div>
                                    </div>
                                </Popover.Panel>
                            </Transition>
                        </>
                    )}
                </Popover>
                <Popover className="relative">
                    {({ open }) => (
                        <>
                            <Popover.Button className={classNames(open && '', 'p-1.5 rounded-lg inline-flex items-center text-gray-700 hover:text-opacity-100 focus:outline-none ml-2')}>
                                <HiOutlineBell color={open ? '#F48735' : 'gray'} fontSize={26} />

                            </Popover.Button>
                            <Transition
                                as={Fragment}
                                enter="transition ease-out duration-200"
                                enterFrom="opacity-0 translate-y-1"
                                enterTo="opacity-100 translate-y-0"
                                leave="transition ease-in duration-150"
                                leaveFrom="opacity-100 translate-y-0"
                                leaveTo="opacity-0 translate-y-1"
                            >
                                <Popover.Panel className='absolute right-0 z-10 mt-2.5 w-80'>
                                    <div className='bg-white rounded-sm shadow-md ring-1 ring-black ring-opacity-5 px-2 py-2.5'>
                                        <strong className='text-gray-700 font-medium'>Notifications</strong>
                                        <div className='mt-2 py-1 text-sm'>
                                            This is the notification panel
                                        </div>
                                    </div>
                                </Popover.Panel>
                            </Transition>
                        </>
                    )}
                </Popover>

                <Menu as="div" className="relative">
                    <div>
                        <Menu.Button className='ml-4 inline-flex  focus:outline-none '>
                            <div className='h-10 w-10 rounded-lg bg-sky-500 bg-cover bg-no-repeat bg-center' style={{ backgroundImage: 'url("https://ui-avatars.com/api/?name=John Doe&background=random")' }}>
                                <span className='sr-only'>Username</span>
                            </div>
                            <div className='flex flex-col items-start ml-4'>
                                <span className='text-white text-sm'>{user.companyName ? user.companyName : user.role === 'super_admin' ? 'Minerva' : ''}</span>
                                <span className='text-white text-sm font-thin'>{user.role ? user.role : ''}</span>
                            </div>
                        </Menu.Button>
                    </div>
                    <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                    >
                        <Menu.Items className="origin-top-right z-10 absolute right-20 mt-2 w-52 rounded-sm shadow-md p-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">

                            <Menu.Item>
                                {({ active }) => (<div className={classNames(active && 'bg-gray-100', 'text-gray-700 focus:bg-gray-200 cursor-pointer rounded-sm px-4 py-2')} onClick={() => handleNavigation('/superAdminDashboard')}>Account Management</div>)}
                            </Menu.Item>
                            <Menu.Item>
                                {({ active }) => (<div className={classNames(active && 'bg-gray-100', 'text-gray-700 focus:bg-gray-200 cursor-pointer rounded-sm px-4 py-2')} onClick={() => handleNavigation('/settings')}>Settings</div>)}
                            </Menu.Item>
                            <Menu.Item>
                                {({ active }) => (<div className={classNames(active && 'bg-gray-100', 'text-gray-700 focus:bg-gray-200 cursor-pointer rounded-sm px-4 py-2')} onClick={() => handleNavigation(async () => { await logoutUser(dispatch, logout); navigate('/login'); })}>Log out</div>)}
                            </Menu.Item>


                        </Menu.Items>
                    </Transition>
                </Menu>
                {/* <div className='flex flex-col'>
                <span className='text-white text-sm ml-2'>John Doe</span>
                <span className='text-white text-sm ml-2 font-thin'>Admin</span>
            </div> */}



            </div>
        </div>
    )
}

export default Header